export default "/sliders-solid.f9def6cf6eeed0213142aa7b62bee401.svg";